import { useMemo } from 'react';

import { GraphsNode } from '@data';
import { useCategories, useUiGraph } from '@queries';

/**
 * A hook for working with time series graphs.
 * We omit the key graph and return:
 * - a list of graph types
 * - a map of graph type as key and corresponding graphs list as value.
 */
export const useTimeSeriesGraphs = () => {
    const { data: graphTypes = [] } = useCategories('graph_type');
    const timeSeriesGraphTypes = useMemo(() => graphTypes.filter((type) => type.id !== 'graph_type.key'), [graphTypes]);

    const { data: graphs = [] } = useUiGraph();
    const graphsByGraphType = useMemo(() => {
        return graphs.reduce(
            (acc, graph) => {
                const { graphType } = graph.categories;
                if (graphType === 'graph_type.key') {
                    return acc;
                }

                if (!acc[graphType]) {
                    acc[graphType] = [];
                }

                acc[graphType].push(graph);
                return acc;
            },
            {} as Record<string, GraphsNode[]>,
        );
    }, [graphs]);

    return { graphTypes: timeSeriesGraphTypes, graphsListByType: graphsByGraphType };
};
